import SEO from "@/components/SEO";
export default function ModernSlaveryPage() {
  return (
    <div className="min-h-screen bg-white text-black px-6 md:px-20 pt-32 pb-12">
      <SEO
        title="Modern Slavery Statement | VANCO"
        description="VANCO's statement on preventing slavery, forced labor and human trafficking in our business and supply chain."
        path="/modern-slavery"
      />
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-semibold mb-8">Modern Slavery Statement</h1>

        <h3 className="text-xl font-normal mb-4">1. Introduction</h3>

        <p className="mb-4 font-light">
          VANCO is committed to ensuring that there is no slavery, forced or compulsory human labor, abuse of power over vulnerable individuals, human trafficking, or any other
          form of exploitation, as contemplated by the UK&apos;s Modern Slavery Act 2015, in any part of the organization.
        </p>
        <p className="mb-4 font-light">
          We are committed to fully complying with all applicable laws, rules, and regulations, in order to militate against the risk of human trafficking in our business and
          supply chains.
        </p>

        <h3 className="text-xl font-normal mb-4">2. Organization</h3>

        <p className="mb-4 font-light">
          VANCO is an enterprise AI development company headquartered in Bengaluru, India, and part of Codebugged, a technology
          company founded in 2018. We design and build custom AI, automation and full-stack software for organizations across
          industries including consumer goods, consumer electronics, construction, fintech, education, media and the public sector.
        </p>

        <p className="mb-4 font-light">
          Our business is primarily professional services delivered by our own engineering teams. Our supply chain mainly consists
          of cloud and software providers, IT hardware suppliers, workspace providers and professional service partners.
        </p>

        <h3 className="text-xl font-normal mb-4">3. Policies in Relation to Slavery and Human Trafficking</h3>

        <p className="mb-4 font-light">
          We recruit employees and suppliers in a lawful and professional manner, using systems and controls to ensure slavery and human trafficking is not taking place anywhere
          within our business or supply chains. The same can be found in our VANCO Code of Conduct document as well.
        </p>

        <p className="mb-4 font-light">
          We are committed to creating and ensuring an open and transparent working environment for our staff so they can express workplace and supply chain concerns without
          any risk of retaliation.
        </p>

        <h3 className="text-xl font-normal mb-4">Code of Conduct</h3>

        <p className="mb-4 font-light">
          Upon hire, all VANCO employees receive training which enables them:
        </p>

        <ul className="list-disc pl-6 mb-6 space-y-2 font-light">
          <li>
            To become familiar with, and conduct business in compliance with, applicable laws, rules and regulations and Company policies;
          </li>
          <li>
            To treat all other persons in an honest and fair manner;
          </li>
          <li>
            To avoid situations in which the employee&apos;s personal interests are, or may appear to be, in conflict with our interests; and
          </li>
          <li>
            To safeguard and use properly all Company information, assets, and resources, as well as those of our customers and business partners.
          </li>
        </ul>

        <p className="mb-4 font-light">
          Should any employee become aware of suspected misconduct or illegal activities, they are expected to report such matters. VANCO prohibits any director, officer, or
          employee from retaliating or taking adverse action against anyone for raising suspected conduct violations or cooperating with any investigation of such allegations.
        </p>

        <h3 className="text-xl font-normal mb-4">4. Due Diligence Processes</h3>

        <p className="mb-4 font-light">
          We are committed to achieving the highest standards of quality and integrity in all our business operations, and we expect the same of suppliers doing business with VANCO.
          We will not support or deal with any business knowingly involved in slavery or human trafficking.
        </p>

        <h3 className="text-xl font-normal mb-4">5. Employee Education on Modern Slavery and Trafficking</h3>

        <p className="mb-4 font-light">
          Our Modern Slavery Statement is available at all times to employees through our website. New employees will be required to review and confirm their understanding of
          our Modern Slavery Statement as part of the onboarding process.
        </p>
      </div>
    </div>
  );
}
